var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"navigation-bar-space",class:{
        'd-lg-none': _vm.hideLg,
    }},[_c('nav',{staticClass:"navigation-bar transition-up-1"},[_c('div',{staticClass:"navigation-bar-grid py-h",class:{
                'page-container': !_vm.wide,
                'page-container-wide': _vm.wide
            }},[_c('div',{staticClass:"nb-left"},[_vm._t("left")],2),_vm._v(" "),_c('div',{staticClass:"nb-center max-lines-2"},[_vm._t("center")],2),_vm._v(" "),_c('div',{staticClass:"nb-right"},[_vm._t("right")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }